import { render } from "./RosterView.vue?vue&type=template&id=98d8c114"
import script from "./RosterView.vue?vue&type=script&lang=js"
export * from "./RosterView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__